import React from 'react';

const StatTile = ({ label, value, sub, color }) => (
  <div className="stat-tile">
    <div className="stat-label">{label}</div>
    <div className={`stat-value ${color === 'neon' ? 'neon' : color === 'cyan' ? 'cyan' : ''}`}>
      {value}
    </div>
    {sub && <div className="stat-sub">{sub}</div>}
  </div>
);

export default StatTile;
